export class AdminStaff {
    public userId: string;
    public brokerId: string;
    public firstName: string;
    public lastName: string;
    public phone: number;
    public email: string;
    public createdOn: string;
}